export default "__VITE_ASSET__Kbps$wRunG_H7mmykwiZyA__"